import { useMutation, useQueryClient } from 'react-query'

import { API_URL } from '../../utils/config'
import { useAxios } from '../index'

const useSourceStatisticsRecalculate = (sourceId, sourceType) => {
  const queryClient = useQueryClient()
  const axios = useAxios()

  const recalculateSourceStatistics = async () => {
    let url = `${API_URL}/${sourceType.toLowerCase()}s/${sourceId}/statistics/recalculate`

    const { data } = await axios.patch(url, {})
    return data
  }

  const queryName = `sources-${sourceType.toLowerCase()}`

  return useMutation(recalculateSourceStatistics, {
    onMutate: async updatedSource => {
      await queryClient.cancelQueries([queryName, updatedSource.id])
      const previousSource = queryClient.getQueryData([
        queryName,
        updatedSource.id,
      ])
      return { previousSource, updatedSource }
    },
    onError: (err, updatedSource, context) => {
      queryClient.setQueryData(
        [queryName, updatedSource.id],
        context.previousSource
      )
    },
    onSettled: updatedSource => {
      queryClient.invalidateQueries([queryName, updatedSource.id])
    },
  })
}

export default useSourceStatisticsRecalculate
